import { apiCall, jwtHeaders } from "./data";

export const getUserProfile = async () => {
  return apiCall("api/user/self", "GET"  );
};

export const getUserNotification = async () => {
  return apiCall("api/notification/user", "GET"  );
};


export const updateUserProfile = async (data) => {
  return apiCall("api/user/update", "PUT", data  );
};

export const sendForgotPasswordOtp = async (data) => {
  return apiCall("api/user/forgot/otpsend", "POST", data  );
};

export const resetPassword = async (data) => {
  return apiCall("api/user/forgot/otpverify", "POST", data  );
};

export const getallCourse = async () => {
  return apiCall("api/course", "GET"  );
}

export const getallCategory = async () => {
  return apiCall("api/category", "GET"  );
}

export const getSingleCourse = async (id) => {
  return apiCall(`api/course/slug/${id}`, "GET"  );
}

// Cart Related Apis 
export const addToCart = async (data) => {
  return apiCall("api/cart/add-to-cart", "POST", data);
};

export const removeFromCart = async (data) => {
  return apiCall("api/cart/remove-from-cart", "POST", data);
};

export const getCartByUser = async () => {
  return apiCall("api/cart/get-cart", "GET");
};

export const updateCartQuantity = async (data) => {
  return apiCall("api/cart/update-quantity", "POST", data);
};

// Wishlist Related Apis

export const addToWishlist = async (data) => {
  return apiCall("api/wishlist/add", "POST", data);
};

export const removeFromWishlist = async (data) => {
  return apiCall("api/wishlist/remove", "POST", data);
};

export const getWishlistByUser = async () => {
  return apiCall("api/wishlist", "GET");
};

export const moveToCart = async (data) => {
  return apiCall("api/wishlist/move-to-cart", "POST", data);
};


// Order Related Apis
export const placeBooking = async (data) => {
  return apiCall("api/booking/create", "POST", data);
};

export const getBookingsByUser = async () => {
  return apiCall("api/booking", "GET");
};

export const cancelBooking = async ({bookingId, ...data}) => {
  return apiCall(`api/booking/cancel/${bookingId}`, "POST", data);
};

export const getPartners = async () => {
  return apiCall("api/partner", "GET");
}

export const getOurTeam = async () => {
  return apiCall("api/team", "GET");
}

export const getOurServices = async () => {
  return apiCall("api/service", "GET");
}

export const getSingleService = async (id) => {
  return apiCall(`api/service/${id}`, "GET");
}


export const ContactWithUs = async (data) => {
  return apiCall("api/leads", "POST", data);
}


export const updatePassword = async (data) => {
  return apiCall("api/user/update/password", "POST", data);
}


export const getAllReviews = async (courseId) => {
  return apiCall(`api/course/${courseId}/reviews`, "GET");
};

export const addReview = async (data, courseId) => {
  return apiCall(`api/course/${courseId}/review`, "POST", data);
};

export const updateReview = async (data, courseId, reviewId) => {
  return apiCall(`api/course/${courseId}/review/${reviewId}`, "PUT", data);
};

export const deleteReview = async (courseId,reviewId) => {
  return apiCall(`api/course/${courseId}/review/${reviewId}`, "DELETE");
};

export const getCourseQuiz = async (courseId) => {
  return apiCall(`api/course/${courseId}/quiz`, "GET");
}

export const getCommunityPosts = async () => {
  return apiCall("api/community", "GET");
}

export const getOurMedia = async () => {
  return apiCall("api/ourMedia", "GET");
}

export const getWorkWithGisul = async () => {
  return apiCall("api/workWithGisul", "GET");
}

export const getCommunityGallery = async () => {
  return apiCall("api/communityGallery", "GET");
}

export const getCommunityAwards = async () => {
  return apiCall("api/communityAwards", "GET");
}

export const getTestimonials = async () => {
  return apiCall("api/testimonials", "GET");
}


export const getWebsitePolicy = async () => {
  return apiCall("api/websitepolicy", "GET");
}

export const getFAQ = async () => {
  return apiCall("api/faq", "GET");
}

export const getLms = async () => {
  return apiCall("api/lms", "GET");
}

export const getLateralHiring = async () => {
  return apiCall("api/lateralHiring", "GET");
}


export const getCorporateHiring = async () => {
  return apiCall("api/corporateHiring", "GET");
}

export const getHireTrainFeature = async () => {
  return apiCall("api/hireTrainFeature", "GET");
}

export const getCloudLabs = async () => {
  return apiCall("api/cloudLabs", "GET");
}

export const getAiAssessment = async () => {
  return apiCall("api/aiAssessment", "GET");
}




